<div class="boxWhite" *ngIf="tipo == 'ERROR'">
  <h4 class="clRed">INFORMACIÓN #{{requestId}}</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" >
  </button>

  <div class="contModal">
    <p><small><strong>Comentario:</strong></small></p>
    <p class="clGray">{{msg}}
      <br>Si el error persiste por
      favor envíe un ticket a TI o contacte
      a conecta.hualpen.cl</p>

  </div>

  <div class="footModal">
    <button class="btn btnRed w-100" (click)="close()">SALIR</button>
  </div>
</div>


<div class="boxWhite" *ngIf="tipo == 'WARNING'">
  <h4 class="clYellow">ATENCIÓN</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" >
  </button>

  <div class="contModal">
    <p class="clGray">{{msg}}
  </div>

  <div class="footModal">
    <button class="btn btnYellow w-100" (click)="close()">SALIR</button>
  </div>
</div>


<div class="boxWhite" *ngIf="tipo == 'INFO'">
  <h4 class="clBlack">OPERACIÓN EXITOSA</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg" >
  </button>

  <div class="contModal">
    <p class="clGray">{{msg}}
  </div>

  <div class="footModal">
    <button class="btn btnBlack w-100" (click)="close()">SALIR</button>
  </div>
</div>
